import React, { useState } from 'react';
import { Button, Form, Input, message } from 'antd';
import user from 'asset/img/login_user.png';
import psw from 'asset/img/login_psw.png';
import bkLogin from 'asset/img/bk-login.webp';
import loginScroll from 'asset/img/login-scroll.png';
import forgotPasswordTitle from 'asset/img/forgot-password-title.png';
import back from 'asset/img/back.png';
import { useNavigate } from 'react-router-dom';
import { userResetpwd } from 'network';
import './index.scss';

const ForgotPassword = () => {
  const [form] = Form.useForm();
  let navigate = useNavigate();

  const handleBack = () => {
    navigate(`/login`);
  };

  const onFinish = (values) => {
    userResetpwd({ mobile: values?.mobile, pwd: values?.pwd }).then(res => {
      navigate(`/login`);
      message.info('密码修改成功');
    })
  };

  // 正则表达式，用于验证密码是否包含大小写字母和数字
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/;
  const passwordErrorMessage = '密码需包含字母和数字，且长度至少为8位';

  return (
    <div className='forgotPassword-container'>
      {/* 背景图片 */}
      <img src={bkLogin} alt="" className="forgotPassword-bg-img" />
      
      {/* 飘动的云朵 */}
      <div className="forgotPassword-clouds">
        <div className="cloud cloud-1"></div>
        <div className="cloud cloud-2"></div>
        <div className="cloud cloud-3"></div>
      </div>
      
      {/* 返回按钮 */}
      <div className='forgotPassword-back' onClick={handleBack}>
        <img src={back} alt="返回" />
      </div>
      
      {/* 卷轴登录框 */}
      <div className='forgotPassword-card'>
        <img src={loginScroll} alt="" className='forgotPassword-scroll-img' aria-hidden />
        <div className='forgotPassword-card-inner'>
          <img src={forgotPasswordTitle} alt="忘记密码" className='forgotPassword-title-img' />
          <Form
            name="forgotPassword"
            form={form}
            onFinish={onFinish}
            className='forgotPassword-form'
          >
          <Form.Item
            name="mobile"
            rules={[
              { required: true, message: '请输入手机号' },
              { type: 'string', pattern: /^1[3-9]\d{9}$/, message: '请输入有效的手机号' },
            ]}
          >
            <Input 
              prefix={<img src={user} className='input-icon' />} 
              placeholder="请输入手机号" 
              type="number"
            />
          </Form.Item>

          <Form.Item
            name="pwd"
            rules={[
              { required: true, message: '请输入新密码' },
              { pattern: passwordRegex, message: passwordErrorMessage },
            ]}
          >
            <Input.Password 
              prefix={<img src={psw} className='input-icon' />} 
              placeholder="请输入新密码" 
            />
          </Form.Item>

          <Form.Item
            name="pwdSame"
            rules={[
              { required: true, message: '请再次输入密码' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('pwd') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('两次输入的密码不一致'));
                },
              }),
            ]}
          >
            <Input.Password 
              prefix={<img src={psw} className='input-icon' />} 
              placeholder="请再次输入密码" 
            />
          </Form.Item>

          <Form.Item className='forgotPassword-btn-wrap'>
            <Button block type="primary" htmlType="submit" className='forgotPassword-btn'>
              确认修改
            </Button>
          </Form.Item>
        </Form>
          <div className='forgotPassword-footer'>
            <span className='footer-text'>想起密码了?</span>
            <span className='footer-link' onClick={handleBack}>返回登录</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
